var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import mobx, { action, computed, observable, runInAction } from 'mobx';
import moment from 'moment';
import { api } from '../../helpers/Api';
var OperationalCalendarStore = /** @class */ (function () {
    function OperationalCalendarStore() {
        // Estado observable
        this.startDate = moment().startOf('day');
        this.daysToShow = 7;
        this.experiences = [];
        this.slots = [];
        this.loading = false;
        this.error = null;
        // Modal de detalle
        this.selectedSlot = null;
        this.modalOpen = false;
    }
    Object.defineProperty(OperationalCalendarStore.prototype, "dateRange", {
        // ============================================
        // COMPUTED
        // ============================================
        get: function () {
            console.log('dateRange - this.startDate', this.startDate);
            var dates = [];
            for (var i = 0; i < this.daysToShow; i++) {
                dates.push(moment(this.startDate).add(i, 'days'));
            }
            return dates;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OperationalCalendarStore.prototype, "endDate", {
        get: function () {
            return moment(this.startDate).add(this.daysToShow - 1, 'days');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OperationalCalendarStore.prototype, "slotsByExperience", {
        // TODO 
        get: function () {
            var _this = this;
            var result = {};
            console.log('getSlotByExperience - this.experiences', mobx.toJS(this.experiences));
            console.log('getSlotByExperience - this.experiences', mobx.toJS(this.slots));
            this.experiences.forEach(function (exp) {
                result[exp.id] = {};
                _this.dateRange.forEach(function (date) {
                    var dateStr = date.format('YYYY-MM-DD');
                    result[exp.id][dateStr] = _this.slots.filter(function (slot) { return slot.experience_id === exp.id && slot.date === dateStr; }).sort(function (a, b) { return a.time.localeCompare(b.time); });
                });
            });
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OperationalCalendarStore.prototype, "dateRangeLabel", {
        get: function () {
            if (this.daysToShow === 1) {
                return this.startDate.format('dddd, D MMMM YYYY');
            }
            return "".concat(this.startDate.format('D MMM'), " - ").concat(this.endDate.format('D MMM YYYY'));
        },
        enumerable: false,
        configurable: true
    });
    // ============================================
    // ACCIONES - NAVEGACIÓN
    // ============================================
    OperationalCalendarStore.prototype.setDaysToShow = function (days) {
        this.daysToShow = days;
        this.fetchSlots();
    };
    OperationalCalendarStore.prototype.nextPeriod = function () {
        this.startDate = moment(this.startDate).add(this.daysToShow, 'days');
        this.fetchSlots();
    };
    OperationalCalendarStore.prototype.prevPeriod = function () {
        this.startDate = moment(this.startDate).subtract(this.daysToShow, 'days');
        this.fetchSlots();
    };
    OperationalCalendarStore.prototype.goToToday = function () {
        this.startDate = moment().startOf('day');
        this.fetchSlots();
    };
    // ============================================
    // ACCIONES - FETCH (MOCK POR AHORA)
    // ============================================
    OperationalCalendarStore.prototype.fetchSlots = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response_1, err_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.error = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.get('/calendar/slots', {
                                params: {
                                    startDate: this.startDate.format('YYYY-MM-DD'),
                                    endDate: this.endDate.format('YYYY-MM-DD'),
                                }
                            })];
                    case 2:
                        response_1 = _a.sent();
                        runInAction(function () {
                            _this.experiences = response_1.experiences;
                            _this.slots = response_1.slots;
                            _this.loading = false;
                            console.log('this.experiences', JSON.stringify(_this.experiences));
                            console.log('this.slots', JSON.stringify(_this.slots));
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        runInAction(function () {
                            _this.error = 'Error al cargar los datos';
                            _this.loading = false;
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // ============================================
    // ACCIONES - MODAL
    // ============================================
    OperationalCalendarStore.prototype.openSlotDetail = function (slot) {
        this.selectedSlot = slot;
        this.modalOpen = true;
    };
    OperationalCalendarStore.prototype.closeModal = function () {
        this.selectedSlot = null;
        this.modalOpen = false;
    };
    // ============================================
    // ACCIONES - MODIFICACIÓN SLOTS
    // ============================================
    OperationalCalendarStore.prototype.toggleSalesOpen = function (slotId) {
        return __awaiter(this, void 0, Promise, function () {
            var slot;
            return __generator(this, function (_a) {
                slot = this.slots.find(function (s) { return s.id === slotId; });
                if (!slot)
                    return [2 /*return*/];
                try {
                    // TODO: Llamada real al API
                    // await api.patch(`/calendar/slots/${slotId}`, { salesOpen: !slot.salesOpen })
                    runInAction(function () {
                        slot.salesOpen = !slot.salesOpen;
                    });
                }
                catch (err) {
                    console.error('Error al cambiar estado de venta', err);
                }
                return [2 /*return*/];
            });
        });
    };
    OperationalCalendarStore.prototype.setGroupName = function (slotId, groupName) {
        return __awaiter(this, void 0, Promise, function () {
            var slot;
            return __generator(this, function (_a) {
                slot = this.slots.find(function (s) { return s.id === slotId; });
                if (!slot)
                    return [2 /*return*/];
                try {
                    // TODO: Llamada real al API
                    // await api.patch(`/calendar/slots/${slotId}`, { groupName })
                    runInAction(function () {
                        slot.groupName = groupName;
                    });
                }
                catch (err) {
                    console.error('Error al cambiar nombre de grupo', err);
                }
                return [2 /*return*/];
            });
        });
    };
    OperationalCalendarStore.prototype.updateCapacity = function (slotId, capacity) {
        return __awaiter(this, void 0, Promise, function () {
            var slot;
            return __generator(this, function (_a) {
                slot = this.slots.find(function (s) { return s.id === slotId; });
                if (!slot)
                    return [2 /*return*/];
                try {
                    // TODO: Llamada real al API
                    // await api.patch(`/calendar/slots/${slotId}`, { capacity })
                    runInAction(function () {
                        slot.capacity = capacity;
                        slot.available = Math.max(0, capacity - (slot.sold.own + Object.values(slot.sold.external).reduce(function (a, b) { return a + b; }, 0)) - slot.blocked);
                        slot.hasOverbooking = slot.available < 0;
                    });
                }
                catch (err) {
                    console.error('Error al cambiar capacidad', err);
                }
                return [2 /*return*/];
            });
        });
    };
    // ============================================
    // ACCIONES - BLOQUEOS
    // ============================================
    OperationalCalendarStore.prototype.addBlock = function (slotId, data) {
        return __awaiter(this, void 0, Promise, function () {
            var slot, newBlock_1;
            return __generator(this, function (_a) {
                slot = this.slots.find(function (s) { return s.id === slotId; });
                if (!slot)
                    return [2 /*return*/];
                try {
                    newBlock_1 = {
                        id: Math.floor(Math.random() * 10000),
                        quantity: data.quantity,
                        reason: data.reason,
                        expires_at: data.expires_at || null,
                        blocked_by: 1,
                        blocked_byName: 'Admin',
                        created_at: moment().toISOString(),
                    };
                    runInAction(function () {
                        slot.blocks.push(newBlock_1);
                        slot.blocked += data.quantity;
                        slot.available = Math.max(0, slot.capacity - (slot.sold.own + Object.values(slot.sold.external).reduce(function (a, b) { return a + b; }, 0)) - slot.blocked);
                        slot.hasOverbooking = slot.available < 0;
                    });
                }
                catch (err) {
                    console.error('Error al añadir bloqueo', err);
                }
                return [2 /*return*/];
            });
        });
    };
    OperationalCalendarStore.prototype.removeBlock = function (slotId, blockId) {
        return __awaiter(this, void 0, Promise, function () {
            var slot, block;
            return __generator(this, function (_a) {
                slot = this.slots.find(function (s) { return s.id === slotId; });
                if (!slot)
                    return [2 /*return*/];
                block = slot.blocks.find(function (b) { return b.id === blockId; });
                if (!block)
                    return [2 /*return*/];
                try {
                    // TODO: Llamada real al API
                    // await api.delete(`/calendar/slots/blocks/${blockId}`)
                    runInAction(function () {
                        slot.blocks = slot.blocks.filter(function (b) { return b.id !== blockId; });
                        slot.blocked -= block.quantity;
                        slot.available = Math.max(0, slot.capacity - (slot.sold.own + Object.values(slot.sold.external).reduce(function (a, b) { return a + b; }, 0)) - slot.blocked);
                        slot.hasOverbooking = slot.available < 0;
                    });
                }
                catch (err) {
                    console.error('Error al eliminar bloqueo', err);
                }
                return [2 /*return*/];
            });
        });
    };
    __decorate([
        observable
    ], OperationalCalendarStore.prototype, "startDate", void 0);
    __decorate([
        observable
    ], OperationalCalendarStore.prototype, "daysToShow", void 0);
    __decorate([
        observable
    ], OperationalCalendarStore.prototype, "experiences", void 0);
    __decorate([
        observable
    ], OperationalCalendarStore.prototype, "slots", void 0);
    __decorate([
        observable
    ], OperationalCalendarStore.prototype, "loading", void 0);
    __decorate([
        observable
    ], OperationalCalendarStore.prototype, "error", void 0);
    __decorate([
        observable
    ], OperationalCalendarStore.prototype, "selectedSlot", void 0);
    __decorate([
        observable
    ], OperationalCalendarStore.prototype, "modalOpen", void 0);
    __decorate([
        computed
    ], OperationalCalendarStore.prototype, "dateRange", null);
    __decorate([
        computed
    ], OperationalCalendarStore.prototype, "endDate", null);
    __decorate([
        computed
    ], OperationalCalendarStore.prototype, "slotsByExperience", null);
    __decorate([
        computed
    ], OperationalCalendarStore.prototype, "dateRangeLabel", null);
    __decorate([
        action
    ], OperationalCalendarStore.prototype, "setDaysToShow", null);
    __decorate([
        action
    ], OperationalCalendarStore.prototype, "nextPeriod", null);
    __decorate([
        action
    ], OperationalCalendarStore.prototype, "prevPeriod", null);
    __decorate([
        action
    ], OperationalCalendarStore.prototype, "goToToday", null);
    __decorate([
        action
    ], OperationalCalendarStore.prototype, "fetchSlots", null);
    __decorate([
        action
    ], OperationalCalendarStore.prototype, "openSlotDetail", null);
    __decorate([
        action
    ], OperationalCalendarStore.prototype, "closeModal", null);
    __decorate([
        action
    ], OperationalCalendarStore.prototype, "toggleSalesOpen", null);
    __decorate([
        action
    ], OperationalCalendarStore.prototype, "setGroupName", null);
    __decorate([
        action
    ], OperationalCalendarStore.prototype, "updateCapacity", null);
    __decorate([
        action
    ], OperationalCalendarStore.prototype, "addBlock", null);
    __decorate([
        action
    ], OperationalCalendarStore.prototype, "removeBlock", null);
    return OperationalCalendarStore;
}());
export default OperationalCalendarStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Calendar/Store.ts
// module id = 758
// module chunks = 0